import BaseService from './_base.service';

export const dealerfamilyService = {
    page,
    search,
    combo,
    edit,
    create,
    one,
    remove,
    removeLogic
};

function page(page,size, callback) {
    return BaseService.get("/dealer/family/page/"+page+"/"+size, callback, true)
}
function search(page,size,filter, callback) {
    return BaseService.post("/dealer/family/page/"+page+"/"+size,filter, callback, true)
}

function combo( callback) {
    return BaseService.get("/dealer/family/combo/", callback, true)
}

function edit(id, bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.put("/dealer/family/"+id, body, callback, true)
}

function create(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post("/dealer/family/", body, callback, true)
}

function one(id,callback) {
    return BaseService.get("/dealer/family/one/"+id, callback);
}

function remove(id,callback) {
    return BaseService.delete("/dealer/family/"+id, callback);
}

function removeLogic(id,callback) {
    return BaseService.delete("/dealer/family/"+id+"/logic", callback);
}
